<template lang="pug">
  #app.user-layout
    main-header()
    left-menu()
    user-nav(v-if="!error")
    template
      e-error(v-if="error" :error="error")
      router-view(v-else)
    user-footer
</template>
<script>
  import userNav from './components/user-nav.vue'
  import userFooter from './components/user-footer.vue'

  export default {
    name: 'components-layout',
    components: {
      userNav, userFooter
    },
    computed: {
      error () {
        return this.$store.getters.getError
      }
    }
  }
</script>
